export default "__VITE_ASSET__DZoIZWpF__"